import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './admin-ui.css'
import '@/locales/i18n'
import { purgeLegacyMentalHealthStorage } from '@/util/purgeLegacyMentalHealthStorage'
import { installToolbarCollapseGap } from '@/util/toolbarCollapseGap'

// async function enableMocking() {
//     const { worker } = await import('./mocks/browser')
//     return worker.start()
// }

purgeLegacyMentalHealthStorage()
installToolbarCollapseGap()

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
)
